










import { Component, Vue } from "vue-property-decorator";

import BreadcrumbList, {
  BreadcrumbData,
} from "@/components/common/breadcrumb/BreadcrumbList.vue";
import ImportantOldList from "@/components/important-message/ImportantOldList.vue";
import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import { RouteName } from "@/consts/route";
import { ImportantMessageInterface } from "@/interfaces/important-message.interface";
import { ViewUtil } from "@/utils/view.util";

@Component({
  components: {
    BreadcrumbList,
    ImportantOldList,
    FlexibleContentArea,
  },
})

export default class ImportantOldPage extends Vue {
  private importantMessages: ImportantMessageInterface[] = [];

  async mounted(): Promise<void> {
    this.showLoading();
    ViewUtil.scrollToTop();

    await this.loadImportantMessages();

    this.hideLoading();
  }

  private get breadcrumbs(): BreadcrumbData[] {
    return [
      { name: "Home", route: RouteName.Home },
      {
        name: this.$t("message.ImportantOldPage.breadcrumbs").toString(),
        route: RouteName.ImportantOld
      },
    ];
  }

  private loadImportantMessages(): Promise<void> {
    return this.$api
      .getImportantOld()
      .then((messages: ImportantMessageInterface[]) => {
        this.importantMessages = messages;
      })
      .catch(() => {
        this.errorToast(this.$t("message.ImportantOldPage.error_toast").toString());
      });
  }
}

